export const CASES = {
  UPDATE_OFFER_HISTORY: "OFFER_HISTORY/UPDATE_OFFER_HISTORY",
  UPDATE_OFFER_HISTORY_FILTERS: "OFFER_HISTORY/UPDATE_OFFER_HISTORY_FILTERS",
  SET_OFFER_HISTORY_FILTERS: "OFFER_HISTORY/SET_OFFER_HISTORY_FILTERS",
  LOAD_OFFER_HISTORY_FILTERS: "OFFER_HISTORY/LOAD_OFFER_HISTORY_FILTERS",
  CLEAR_OFFER_HISTORY_FILTERS: "OFFER_HISTORY/CLEAR_OFFER_HISTORY_FILTERS",
};
